<template>
  <tg-layout>
    <template slot="header">
      <tg-search-tool @on-submit="handleSearch">
        <el-input
          :placeholder="$t('component.form.input.placeholder.trial')"
          v-model="searchData.username"
          class="tg-input"
          size="small"
          style="width: 230px"
          clearable
        ></el-input>
      </tg-search-tool>
    </template>
    <tg-table
      ref="table"
      :columns="columns"
      :proxy="proxy"
      align="center"
      :fit="true"
      :showSummary="!isDetail"
      :summary-method="parseSummary"
      @on-loaded="handleLoaded"
    >
      <template slot="userfullname" slot-scope="scope">
        <tg-user-full-name
          v-bind="scope"
          :class="{'as-link': scope.row.group != 10 && !isDetail}"
          @click.native="(scope.row.group != 10 && !isDetail) ? handleUserClick(scope.value) : null"
        ></tg-user-full-name>
      </template>
      <template v-slot:blockedStatus="props">
        <tg-blocked-status :blocked="props.value"></tg-blocked-status>
      </template>
      <template slot="apply" slot-scope="scope">
        <template v-if="scope.row.group == 20 && !isSub">
          <tg-trial-btn
            :num="scope.value"
            @click.native="scope.value == 0 ? null : handleApply(scope.row)"
          ></tg-trial-btn>
        </template>
        <template v-else>{{scope.value}}</template>
      </template>
    </tg-table>
  </tg-layout>
</template>

<script>
import TgLayout from "@/layout/TgLayout";
import TgTable from "@/components/table/TgTable";
import TgSearchTool from "@/components/tool/TgSearchTool";
import TgTrialBtn from "@/components/button/TgTrialBtn";
import TgUserFullName from "@/components/slot/TgUserFullName";
import TgBlockedStatus from "@/components/slot/TgBlockedStatus";

import { summary } from "@/utils/table";
import apis from "@/apis";
const api = apis.member.trial;

import str from "@/utils/str";

export default {
  components: {
    TgLayout,
    TgTable,
    TgSearchTool,
    TgTrialBtn,
    TgUserFullName,
    TgBlockedStatus,
  },
  data() {
    return {
      columns: [],
      detailColumns: [],
      normalColumns: [],
      proxy: api.getData,
      searchData: {
        username: "",
      },
      groupTag: "",
      upperGroupTag: "",
      amountData: {},
      clicked: "",
      isDetail: false,
    };
  },
  props: {
    hasUser: Boolean,
  },
  computed: {
    username() {
      return this.$route.params.username;
    },
  },
  created() {
    if (this.$route.params.username && !this.clicked) {
      this.$router.push({ name: "member.trial.index" });
    }

    api.getColumns().then((response) => {
      this.normalColumns = response.data.normalColumns;
      this.detailColumns = response.data.detailColumns;
      this.columns = response.data.normalColumns;
      this.$nextTick(() => {
        this.$refs.table.init();
      });
    });
  },
  methods: {
    handleLoaded(response) {
      this.upperGroupTag = response.upperGroupTag;
      this.groupTag = response.groupTag;

      // is trial account
      if (response.group == 10) {
        this.columns = this.detailColumns;
        this.isDetail = true;
      } else {
        let columns = [...this.normalColumns];
        columns[0].langKey = response.groupTag
          ? response.groupTag + "_account"
          : "userfullname";
        this.columns = columns;
        this.amountData = response.total;
        this.isDetail = false;
      }
      this.$nextTick(() => {
        if (this.clicked) {
          this.addBreadcrumb(response.upperGroupTag);
        } else {
          this.$store.commit("breadcrumb/clear");
        }
      });
    },
    addBreadcrumb(hasTag) {
      let title = str.format(
        "{0} ({1})",
        this.$t("column." + this.upperGroupTag),
        this.clicked
      );

      if (!hasTag) {
        title = this.clicked;
      }

      this.$store.commit("breadcrumb/add", {
        id: "member.trial.user_" + this.clicked,
        name: "member.trial.user",
        query: {
          ...this.$route.query,
        },
        params: {
          username: this.clicked,
        },
        meta: {
          title: title,
        },
      });
    },
    handleSearch() {
      this.$refs.table.search(this.searchData);
    },
    /**
     * 解析合計資訊
     */
    parseSummary() {
      return summary(
        this.columns,
        this.amountData ? [this.amountData] : [],
        this.$t("component.table.summary"),
        0
      );
    },
    handleUserClick(username) {
      this.searchData.username = "";
      this.clicked = username;
      this.$router.push({
        name: "member.trial.user",
        params: { username },
      });
    },
    togglePage(hasUser, route) {
      if (hasUser) {
        this.clicked = route.params.username;
        this.$refs.table.search({ targetName: route.params.username });
      } else {
        this.$store.commit("breadcrumb/clear");
        this.clicked = null;
        this.$refs.table.init();
      }
    },
    handleApply(row) {
      this.$router.push({
        name: "member.trial.apply",
        params: {
          username: row.username,
        },
      });
    },
  },
  watch: {
    hasUser(val) {
      this.togglePage(val, this.$route);
    },
  },
  beforeRouteUpdate(to, from, next) {
    this.togglePage(to.params.username, to);

    next();
  },
};
</script>